<button mat-button aria-label="form.name" class="form-btn" (click)="openForm($event)">
  <mat-icon
    class="form-link"
    [ngClass]="form.icon"
    *ngIf="showIcon"></mat-icon>
  <span class="form-link-title">{{ displayName }}</span>
</button>
